import { render, staticRenderFns } from "./users-bond.page.vue?vue&type=template&id=0c5fdff2"
import script from "./users-bond.page.vue?vue&type=script&lang=ts"
export * from "./users-bond.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports